





























import { Component, Prop, Vue } from 'vue-property-decorator';
import GroupAccessView from '@/components/access/GroupAccessView.vue';
import { Subscription } from '@/types/core-push';

@Component({
  components:{
    GroupAccessView
  }
})
export default class SubFilters extends Vue {
  
  @Prop({ default: {},  type: Object}) sub!: Subscription;

  get noFilters():boolean {
    return !this.sub.groupIdList && !this.sub.deviceType;
  }

}
